<template>
  <div>
    <!-- <div class="page_header" style="">
      <span class="page_title" style="flex: 1">{{$t('alarm.一键报警配置')}}</span>
    </div> -->
    <div style="margin-top: 20px; padding: 0px 8px">
      <div style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        ">
        <div class="page_title">{{$t("PersonalizedConfig.一键报警内容配置")}}</div>
        <div style="text-align: right">
          <el-button type="primary" @click="edit" :size="size">{{
            editBtnText
          }}</el-button>
        </div>
      </div>
      <el-divider></el-divider>
      <div style="margin-top: 16px" v-loading="loading">
        <el-form ref="form" :model="form" label-width="140px" :label-position="labelPosition" :rules="rules">
          <el-form-item :label="$t('PersonalizedConfig.一键报警手机号') + '：'" prop="Mobile">
            <el-input :disabled="!isEdit" v-model="form.Mobile" style="width: 500px" :size="size"></el-input>
          </el-form-item>
          <el-form-item :label="$t('PersonalizedConfig.短信模板内容') + '：'" prop="Context">
            <el-input :disabled="!isEdit" :size="size" type="textarea" v-model="form.Context" style="width: 500px" :placeholder="$t('PersonalizedConfig.短信placeholder')"
              :rows="10" maxlength="200" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="">
            <div style="color: #333333; ">
              {{$t("PersonalizedConfig.提示1")}}<span style="color: #ff106e">{{$t("PersonalizedConfig.{车牌号}")}}</span>,<span
                style="color: #ff106e">{{$t("PersonalizedConfig.{车牌号}")}}</span>{{$t("PersonalizedConfig.提示2")}}
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div style="width: 640px; text-align: right; margin-top: 40px" v-show="isEdit">
        <el-button type="primary" @click="onSubmit" :size="size" style="text-align: right">{{ $t("public.confirm")
          }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import language from "@/utils/getLanguageId";
export default {
  data() {
    return {
      loading: false,
      editBtnText: this.$t("PersonalizedConfig.编辑"),
      form: {
        Mobile: "",
        Context: "",
      },
      formItem: {},
      labelPosition: "right",
      LanguageId: 1,
      rules: {
        Mobile: [
          {
            required: true,
            message: this.$t("operatormgr.please_opt_mobile"),
            trigger: "blur",
          },
          {
            type: "string",
            len: 11,
            message: this.$t("PersonalizedConfig.请输入完整手机号"),
            trigger: "blur",
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: this.$t("PersonalizedConfig.请输入正确格式的手机号"),
            trigger: "blur",
          },
        ],
        Context: [
          {
            required: true,
            message: this.$t("PersonalizedConfig.请填写短信模板内容"),
            trigger: "blur",
          },
        ],
      },
      isEdit: false,
    };
  },
  computed: {
    size() {
      return this.$store.getters.size;
    },
  },
  mounted() {
    this.LanguageId = language(this.$store.getters.locale);
    if (this.LanguageId == 1 || this.LanguageId == 2) {
      this.labelPosition = "right";
    } else {
      this.labelPosition = "top";
    }
    this.querySetup();
  },
  methods: {
    edit() {
      if (!this.isEdit) {
        this.isEdit = true;
        this.editBtnText = this.$t("public.cancel");
        this.$message({
          message: this.$t("PersonalizedConfig.进入编辑"),
        });
        this.formItem = JSON.parse(JSON.stringify(this.form));
      } else {
        this.isEdit = false;
        this.editBtnText = this.$t("PersonalizedConfig.编辑");
        this.form = this.formItem;
        this.$refs["form"].resetFields();
        this.$message({
          message: this.$t("PersonalizedConfig.退出编辑"),
        });
      }
    },
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$api
            .setEmergencyAlert(this.form)
            .then((res) => {
              this.querySetup();
            })
            .catch((e) => { });
        } else {
          return false;
        }
      });
    },
    querySetup() {
      this.loading = true;
      this.$api
        .queryEmergencyAlert({})
        .then((res) => {
          this.form.Context = res.data.Context;
          this.form.Mobile = res.data.Mobile;
          this.loading = false;
          if (this.isEdit == true) {
            //手动修改，默认查询不执行
            this.isEdit = false;
            this.editBtnText = this.$t("PersonalizedConfig.编辑");
            this.$message({
              message: this.$t("PersonalizedConfig.配置成功"),
              type: "success",
            });
          }
        })
        .catch((e) => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form-item .el-form-item__content .el-form-item__error {
  position: static;
}
</style>